/** @format */

import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { recargarComponente } from "../../redux/slices/userSlice";
import "./modal.css";
import Swal from "sweetalert2";

export const ModalInformacion = ({ showModal, closeModal, curso }) => {
  const user = useSelector((state) => state.user.id);
  const path = useSelector((state) => state.sitePath);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [cuotaGeneral, setCuotaGeneral] = useState(null);
  const [cuotaSolidarios, setCuotaSolidarios] = useState(null);
  const [cuotaComunidad, setCuotaComunidad] = useState(null);
  const [cuotaEgresados, setCuotaEgresados] = useState(null);
  const email = useSelector((state) => state.user)?.email;

  const verificarCosto = (costo, setCuota, valorAlterno = "No aplica") => {
    if (costo == "0.00" || !costo) {
      if (valorAlterno == "0.00" || !valorAlterno) {
        setCuota("No Aplica");
      } else {
        setCuota(valorAlterno);
      }
    } else {
      setCuota(costo);
    }
  };

  useEffect(() => {
    verificarCosto(curso.aportaciones_costo, setCuotaGeneral, curso.cuota);
    verificarCosto(
      curso.aportaciones_costoComunidadUNAM,
      setCuotaComunidad,
      curso.curso_costoComunidadUNAM
    );
    verificarCosto(
      curso.aportaciones_costoSF,
      setCuotaSolidarios,
      curso.curso_costoSF
    );
    verificarCosto(
      curso.aportaciones_costoEU_CU,
      setCuotaEgresados,
      curso.curso_costoEU_CU
    );
  }, []);

  const inscribeProximoCurso = () => {
    setLoading(true); // Activa el estado de carga
    const obj = {
      to: email,
      id_grupo: curso.id,
      id_alumno: user,
      modalidad: curso.id_modalidad,
    };

    axios
      .post(`${path}/email.php`, obj)
      .then((res) => {
        if (res.data !== "Error") {
          dispatch(recargarComponente());
        }
      })
      .catch((error) => console.error(error.response))
      .finally(() => {
        Swal.fire({
          title: "¡Éxito!",
          text: "Inscripcion exitosa en la seccion mis cursos podra agregar el comprobante de aportación",
          icon: "success",
          confirmButtonText: "OK",
        });

        setLoading(false);
      });
  };

  //Boton pdf curso
  const handleClick = async (event) => {
    event.preventDefault();
    const url = `https://fundacionunam.org/cei/assets/info_cursos/${curso.id_curso}.pdf`;

    try {
      const response = await fetch(url, { method: "HEAD" });
      if (response.ok) {
        const date = new Date();
        const dateTimeInSeconds = Math.floor(date.getTime() / 1000);
        window.open(url + "?v=" + dateTimeInSeconds, "_blank");
      } else {
        alert(`El archivo para el curso: "${curso.curso}" no se encontró.`);
      }
    } catch (error) {
      console.error("Error al intentar abrir el archivo:", error);
      alert(
        "Ocurrió un error al intentar abrir el archivo. Por favor, inténtelo de nuevo más tarde."
      );
    }
  };
  return (
    <div>
      <Modal
        show={showModal}
        onHide={closeModal}
        className='custom-modal'
      >
        <Modal.Header closeButton>
          <Modal.Title>Informacion del Grupo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h3>{curso.curso}</h3>
          <h4>Descripción general:</h4>
          <p>{curso.descripcion}</p>
          <h4>Objetivo general del Diplomado:</h4>
          <p>{curso.objetivo}</p>
          <p>
            <strong>Dirigido a:</strong> {curso.dirigido_a}
          </p>
          <p>
            <strong>Área:</strong> {curso.area}
          </p>
          <p>
            <strong>Opción a titulación:</strong>{" "}
            {curso.op_titulacion == 0 ? "No" : "Sí"}
          </p>
          <div className='modal-details'>
            <ul>
              <li>
                <strong>Duración:</strong> {curso.duracion} horas
              </li>
              <li>
                <strong>Modalidad:</strong> {curso.modalidad}
              </li>
              <li>
                <strong>Sede:</strong> {curso.sede}
              </li>
              <li>
                <strong>Inicio:</strong> {curso.fecha_inicio}
              </li>
            </ul>
            <div className='modal-aportacion'>
              <strong>Aportación:</strong>
              <ul>
                <li>
                  Público en general:
                  <span>{cuotaGeneral}</span>
                </li>
                <li>
                  Egresados UNAM:
                  <span>{cuotaEgresados}</span>
                </li>
                <li>
                  Solidarios FUNAM:
                  <span>{cuotaSolidarios}</span>
                </li>
                <li>
                  Comunidad UNAM:
                  <span>{cuotaComunidad}</span>
                </li>
              </ul>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant='primary'
            onClick={handleClick}
          >
            Más Informacion
          </Button>
          <Button
            variant='primary'
            onClick={inscribeProximoCurso}
          >
            {loading ? "Inscribiendo..." : "Inscribirse"}
          </Button>
          <Button
            variant='secondary'
            onClick={closeModal}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
